module.exports = __webpack_public_path__ + "static/media/calendar-blue-ico.4c04e241.svg";